export default function (attributes) {
    const {duskComponentId, ...attrs} = attributes;
    return attrs;
}
